import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import DataGridActions from './DataGridActions';
import Chip from '@mui/material/Chip';
import {
  GridToolbar,
} from '@mui/x-data-grid-premium';
// import { paymentFilterOperator } from './DataGridComponnent/PaymentFilterOperator';


import { Modal, Button, Typography } from '@mui/material';

function DataGridWithActions({ columns, rows, handleEdit, handleDelete, handleShowPrint, showPayment, height, showDetailsStatus = false, modernStyle = false }) {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);

  const handleDeleteClick = (id) => {
    setDeleteItemId(id); // Vendos id e rreshtit që duhet të fshihet
    setShowDeleteConfirmation(true); // Hap modalin për konfirmim
  };

  const gridColumns = [];

  if (showPayment) {
    gridColumns.push({
      field: 'payments',
      headerName: 'Pagesa',
      renderCell: (params) => (
        <>
          {
            params.row.rowInfo.PaymentOptions === 0 ? (<Chip label="Pa Paguar" color="error" />) : (<Chip label="Paguar" color="success" />)
          }
        </>
      ),
      headerClassName: 'actions-header',
      // filterOperators: [paymentFilterOperator], // kjo është linja e re
    });
  }


  gridColumns.push({
    field: 'actions',
    headerName: 'Veprimet',
    renderCell: (params) => (
      <DataGridActions
        back
        rowData={params.row.rowInfo}
        handleEdit={handleEdit}
        handleDelete={() => handleDeleteClick(params.row.deleteItemId)}
        showDetails={handleShowPrint}
        showDetailsStatus={showDetailsStatus}
      />
    ),
    headerClassName: 'actions-header',
    width: showDetailsStatus ? 150 : 100,
  });

  return (
    <Box
      sx={{
        height: height,
        width: '100%',
        border: modernStyle ? '1px solid #d5dee6' : 'solid lightgray 1px',
        borderRadius: modernStyle ? 3 : 0,
        overflow: modernStyle ? 'hidden' : 'visible',
        backgroundColor: modernStyle ? '#f8fafc' : 'transparent',
        boxShadow: modernStyle ? '0 12px 26px rgba(15, 23, 42, 0.08)' : 'none',
        '& .super-app-theme--header': {
          ...(modernStyle
            ? {
                background: 'linear-gradient(180deg, #2f5a53 0%, #284945 100%)',
                color: '#ffffff',
                fontWeight: 700,
                letterSpacing: '0.2px',
              }
            : {
                backgroundColor: '#284945',
                color: 'white',
              }),
        },
      }}
    >

      <DataGrid
        rows={rows}
        columns={[
          ...columns,
          ...gridColumns
        ]}
        pageSize={15}
        getRowClassName={(params) => {
          const baseClass = params.row.className || '';
          if (!modernStyle) {
            return baseClass;
          }

          const stripeClass =
            params.indexRelativeToCurrentPage % 2 === 0
              ? 'dg-row-even'
              : 'dg-row-odd';

          return `${baseClass} ${stripeClass}`.trim();
        }}
        initialState={{
          density: 'compact'
        }}
        disableRowSelectionOnClick={modernStyle}
        sx={
          modernStyle
            ? {
                border: 0,
                backgroundColor: '#ffffff',
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '1px solid #d5dee6',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontSize: '0.83rem',
                },
                '& .MuiDataGrid-columnSeparator': {
                  opacity: 0.15,
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid #edf2f7',
                  color: '#1f2937',
                  fontSize: '0.86rem',
                },
                '& .MuiDataGrid-row.dg-row-even': {
                  backgroundColor: '#ffffff',
                },
                '& .MuiDataGrid-row.dg-row-odd': {
                  backgroundColor: '#e9f3f0',
                  boxShadow: 'inset 0 1px 0 rgba(40, 73, 69, 0.07), inset 0 -1px 0 rgba(40, 73, 69, 0.07)',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#dbece6',
                },
                '& .MuiDataGrid-row.dg-row-odd:hover': {
                  backgroundColor: '#d7e8e2',
                },
                '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
                  backgroundColor: 'rgba(40, 73, 69, 0.14)',
                },
                '& .MuiDataGrid-toolbarContainer': {
                  padding: '10px 12px',
                  borderBottom: '1px solid #e2e8f0',
                  background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
                },
                '& .MuiDataGrid-toolbarContainer .MuiButton-root': {
                  color: '#355f56',
                  textTransform: 'none',
                  fontWeight: 600,
                },
                '& .MuiDataGrid-toolbarContainer .MuiInputBase-root': {
                  borderRadius: '10px',
                  backgroundColor: '#ffffff',
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: '1px solid #e2e8f0',
                  background: 'linear-gradient(180deg, #fcfdff 0%, #f4f8fb 100%)',
                  minHeight: 54,
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-root': {
                  width: '100%',
                  color: '#334155',
                  fontSize: '0.82rem',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-toolbar': {
                  minHeight: 54,
                  paddingLeft: '12px',
                  paddingRight: '12px',
                  gap: '8px',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-selectLabel, & .MuiDataGrid-footerContainer .MuiTablePagination-displayedRows': {
                  color: '#475569',
                  fontWeight: 600,
                  margin: 0,
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-select': {
                  border: '1px solid #cbd5e1',
                  borderRadius: '8px',
                  padding: '4px 26px 4px 10px',
                  backgroundColor: '#ffffff',
                  fontWeight: 600,
                  color: '#1e293b',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-actions': {
                  marginLeft: '6px',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-actions button': {
                  border: '1px solid #cbd5e1',
                  borderRadius: '9px',
                  padding: '6px',
                  marginLeft: '4px',
                  color: '#2f5a53',
                  backgroundColor: '#ffffff',
                  transition: 'all 0.2s ease',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-actions button:hover': {
                  borderColor: '#9fb8b2',
                  backgroundColor: '#eef6f4',
                },
                '& .MuiDataGrid-footerContainer .MuiTablePagination-actions button.Mui-disabled': {
                  opacity: 0.45,
                  borderColor: '#d8e0e8',
                  color: '#94a3b8',
                },
              }
            : undefined
        }
        slots={{
          toolbar: GridToolbar, // Përdorimi i CustomToolbar në vend të GridToolbar
        }}
        slotProps={{
          toolbar: {
            showQuickFilter: true
          },
        }}
      />
      <style jsx>{`
.actions-header {
  background-color: #284945; /* Ngjyra e sfondit për titullin e kolonës "Actions" */
  color: #FFFFFF; /* Ngjyra e shkronjave e bardhë */
   
}

  .actions-cell {
    background-color: #284945; /* Ngjyra e sfondit për qelizën e kolonës "Actions" */
  }
  .zero-balance-row {
    background-color: lightgray;
  }
  .non-zero-balance-row {
    /* Stili për rreshtat kur 'balance' nuk është 0 */
  }
`}</style>

      {/* Modal për konfirmim të fshirjes */}
      <Modal
        open={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ width: 400, bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
          <Typography id="delete-modal-title" variant="h5">Konfirmim</Typography>
          <Typography id="delete-modal-description" variant="body1">A jeni të sigurt se dëshironi ta fshini këtë rresht</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button variant="contained" color="secondary" onClick={() => { handleDelete(deleteItemId); setShowDeleteConfirmation(false); }}>Po</Button>
            <Button variant="contained" onClick={() => setShowDeleteConfirmation(false)}>Jo</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}


export default DataGridWithActions;
